/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetVideoOptions, GetVideoStatus200, GetVideoStatus422 } from '../models/GetVideo'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getVideo } from '../clients/axios/getVideo'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getVideoQueryKey = ({ path }: Omit<GetVideoOptions, 'headers'>) => [{ url: '/video/:video_id', params: path }] as const

type GetVideoQueryKey = ReturnType<typeof getVideoQueryKey>

export function getVideoQueryOptions({ path }: GetVideoOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getVideoQueryKey({ path })
  return queryOptions<GetVideoStatus200, ResponseErrorConfig<GetVideoStatus422>, GetVideoStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getVideo({ ...config, path, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Video
 * {@link /video/:video_id}
 */
export function useGetVideo<TData = GetVideoStatus200, TQueryData = GetVideoStatus200, TQueryKey extends QueryKey = GetVideoQueryKey>({ path }: { path: GetVideoOptions['path'] | (() => GetVideoOptions['path']) }, options: {
  query?: Partial<QueryObserverOptions<GetVideoStatus200, ResponseErrorConfig<GetVideoStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getVideoQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getVideoQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetVideoStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
